import { render, staticRenderFns } from "./PasswordResetMailInputPane.vue?vue&type=template&id=ac1066ba"
import script from "./PasswordResetMailInputPane.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMailInputPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports